<template>
  <v-container class="charts d-flex flex-column white">
    <v-row no-gutters>
      <v-col cols="12">
        <h4 style="font-size: 24px">{{ title }}</h4>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <fin-chart2 :options="options" constructorType="chart"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FinChart2 from "@/components/common/Chart2/FinChart2"

export default {
  name: 'FinPortfolioDistributionChart',
  components: {FinChart2},
  props: {
    /** Title above pie chart */
    title: {
      type: String
    },
    /** the current assigned values */
    seriesObject: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      chartActualLabel: null,
      chartTargetLabel: null,
      chartHeight: this.$vuetify.breakpoint.mdAndDown ? '155px' : '255px'
    }
  },
  computed: {
    options() {
      const result = {
        credits: {
          enabled: false,
        },
        series: [
          this.seriesObject
        ],
        preset: 'comparePie',
      }

      return result
    },
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
